<template>
  <div class="user-management-container">
    <div class="filter-container">
      <el-form :inline="true" :model="filterForm" class="filter-form">
        <el-form-item label="用户名">
          <el-input
              v-model="filterForm.username"
              placeholder="请输入用户名"
              clearable
              @clear="handleFilter"
              @keyup.enter.native="handleFilter"
          ></el-input>
        </el-form-item>

        <el-form-item label="状态">
          <el-select
              v-model="filterForm.status"
              placeholder="请选择状态"
              clearable
              @change="handleFilter"
          >
            <el-option
                v-for="item in statusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button
              type="primary"
              @click="handleFilter"
          >
            查询
          </el-button>
          <el-button
              @click="resetFilter"
          >
            重置
          </el-button>
        </el-form-item>
        <el-form-item class="add-btn-item">
          <el-button
              type="primary"
              icon="el-icon-plus"
              @click="handleCreate"
          >
            新增用户
          </el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="table-container">
      <el-table
          :data="tableData"
          border
          fit
          highlight-current-row
          style="width: 100%"
          height="calc(100vh - 320px)"
          v-loading="loading"
      >
        <el-table-column
            prop="id"
            label="ID"
            width="80"
            align="center"
        ></el-table-column>

        <el-table-column
            prop="username"
            label="用户名"
            align="center"
            min-width="120"
        ></el-table-column>

        <el-table-column
            prop="name"
            label="姓名"
            align="center"
            min-width="120"
        ></el-table-column>

        <el-table-column
            prop="email"
            label="邮箱"
            align="center"
            min-width="180"
        ></el-table-column>

        <el-table-column
            prop="phone"
            label="手机号"
            min-width="130"
            align="center"
        ></el-table-column>

        <el-table-column
            prop="role"
            label="角色"
            width="120"
            align="center"
        >
          <template slot-scope="{row}">
            <el-tag :type="roleTagType(row.role)">
              {{ row.role | roleFilter }}
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column
            prop="status"
            label="状态"
            width="100"
            align="center"
        >
          <template slot-scope="{row}">
            <el-switch
                v-model="row.status"
                active-value="1"
                inactive-value="0"
                active-color="#13ce66"
                inactive-color="#ff4949"
                @change="handleStatusChange(row)"
            ></el-switch>
          </template>
        </el-table-column>

        <el-table-column
            prop="createTime"
            label="创建时间"
            width="160"
            align="center"
        ></el-table-column>

        <el-table-column
            label="操作"
            width="180"
            align="center"
            fixed="right"
        >
          <template slot-scope="{row}">
            <el-button
                type="text"
                size="small"
                icon="el-icon-edit"
                @click="handleEdit(row)"
            >
              编辑
            </el-button>
            <el-button
                type="text"
                size="small"
                icon="el-icon-delete"
                style="color: #f56c6c"
                @click="handleDelete(row)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-container">
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pagination.currentPage"
            :page-sizes="[10, 20, 30, 50]"
            :page-size="pagination.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pagination.total"
            background
        ></el-pagination>
      </div>
    </div>

    <!-- 新增/编辑用户对话框 -->
    <el-dialog
        :title="dialogTitle"
        :visible.sync="dialogVisible"
        width="600px"
        @close="resetForm"
    >
      <el-form
          ref="userForm"
          :model="userForm"
          :rules="userRules"
          label-width="80px"
      >
        <el-form-item label="账户" prop="accountName">
          <el-input
              v-model="userForm.accountName"
              placeholder="请输入账户"
              @blur="addSuffix"
          >
            <template slot="append">@company.com</template>
          </el-input>
        </el-form-item>

        <el-form-item label="昵称" prop="userName">
          <el-input
              v-model="userForm.userName"
              placeholder="请输入昵称"
          ></el-input>
        </el-form-item>

        <el-form-item label="性别" prop="role">
          <el-select
              v-model="userForm.gender"
              placeholder="请选择性别"
              style="width: 100%"
          >
            <el-option
                v-for="item in genderOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>


        <el-form-item label="邮箱" prop="email">
          <el-input
              v-model="userForm.email"
              placeholder="请输入邮箱"
          ></el-input>
        </el-form-item>

        <el-form-item label="手机号" prop="phone">
          <el-input
              v-model="userForm.phone"
              placeholder="请输入手机号"
          ></el-input>
        </el-form-item>

        <el-form-item label="角色" prop="role">
          <el-select
              v-model="userForm.role"
              placeholder="请选择角色"
              style="width: 100%"
          >
            <el-option
                v-for="item in roleOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                :disabled="item.value !== 'normal'"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="密码" prop="password" v-if="!isEditMode">
          <el-input
              v-model="userForm.password"
              placeholder="请输入密码"
              show-password
              clearable
          ></el-input>
        </el-form-item>

        <!-- 新增确认密码 -->
        <el-form-item label="确认密码" prop="confirmPassword" v-if="!isEditMode">
          <el-input
              v-model="userForm.confirmPassword"
              placeholder="请再次输入密码"
              show-password
              clearable
          ></el-input>
        </el-form-item>

        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="userForm.status">
            <el-radio label="1">启用</el-radio>
            <el-radio label="0">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="submitForm">确 定</el-button>
  </span>
    </el-dialog>
  </div>
</template>

<script>
import {exportJsonToExcel} from '@/utils/export2Excel'

export default {
  name: 'UserManagement',
  filters: {
    roleFilter(role) {
      const roleMap = {
        'admin': '管理员',
        'editor': '编辑',
        'user': '普通用户'
      }
      return roleMap[role] || role
    }
  },
  data() {
    const validatePassword = (rule, value, callback) => {
      if (!this.isEditMode && !value) {
        callback(new Error('请输入密码'));
      } else if (value && value.length < 6) {
        callback(new Error('密码长度不能少于6位'));
      } else {
        callback();
      }
    };

    // 确认密码验证规则
    const validateConfirmPassword = (rule, value, callback) => {
      if (!this.isEditMode && !value) {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.userForm.password) {
        callback(new Error('两次输入密码不一致'));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      filterForm: {
        username: '',
        status: ''
      },
      genderOptions: [
        {value: '1', label: '男'},
        {value: '0', label: '女'}
      ],
      statusOptions: [
        {value: '1', label: '启用'},
        {value: '0', label: '禁用'}
      ],
      roleOptions: [
        {value: '1', label: '管理员', disabled: true},
        {value: '3', label: '普通用户'},
        {value: '2', label: '审计员', disabled: true}
      ],
      tableData: [],
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      isEditMode: false,
      dialogVisible: false,
      dialogTitle: '新增用户',
      userForm: {
        id: '',
        userName: '',
        accountName: '',
        gender: '1',
        email: '',
        phone: '',
        role: '3',
        status: '1',
        password: '',
        confirmPassword: '',
      },

      userRules: {
        accountName: [
          {required: true, message: '请输入账户', trigger: 'blur'},
          {min: 3, max: 20, message: '长度在 3 到 20 个字符', trigger: 'blur'}
        ],
        userName: [
          {required: true, message: '请输入用户名', trigger: 'blur'},
          {min: 2, max: 20, message: '长度在 3 到 20 个字符', trigger: 'blur'}
        ],
        password: [
          {required: true, message: '请输入密码', trigger: 'blur'},
          {validator: validatePassword, trigger: 'blur'}
        ],
        confirmPassword: [
          {required: true, message: '请再次输入密码', trigger: 'blur'},
          {validator: validateConfirmPassword, trigger: 'blur'}
        ],

        email: [
          // {required: true, message: '请输入邮箱', trigger: 'blur'},
          {type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change']}
        ],
        phone: [
          // {required: true, message: '请输入手机号', trigger: 'blur'},
          {pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur'}
        ],
        role: [
          {required: true, message: '请选择角色', trigger: 'change'}
        ],
        gender: [
          {required: true, message: '请选择性别', trigger: 'change'}
        ]
      }
    }
  },
  created() {
    this.getAccountSize();
    this.getUserList();
  },
  methods: {
    getAccountSize() {
      this.$api.account.getAccountSize({
        searchKey: this.filterForm.username,
        status: this.filterForm.status,
      }).then(res => {
        if (res.statusCode === 100200) {
          this.pagination.total = res.data
        }
      })
    },
    // 获取用户列表
    getUserList() {
      this.loading = true

      this.$api.account.getAccounts({
        searchKey: this.filterForm.username,
        status: this.filterForm.status,
        pageSize: this.pagination.pageSize,
        currentPage: this.pagination.currentPage,
      }).then(res => {
        if (res.statusCode === 100200) {
          this.tableData = res.data
        }
      }).catch().finally(() => {
        this.loading = false
      })
    },
    addSuffix() {
      if (this.userForm.accountName && !this.userForm.accountName.endsWith('@company.com')) {
        this.userForm.accountName += '@company.com';
      }
    },

    // 格式化日期
    formatDate(date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      return `${year}-${month}-${day} ${hours}:${minutes}`
    },

    // 角色标签类型
    roleTagType(role) {
      const typeMap = {
        'admin': 'danger',
        'editor': 'warning',
        'user': 'success'
      }
      return typeMap[role] || ''
    },

    // 筛选
    handleFilter() {
      this.pagination.currentPage = 1
      this.getUserList()
    },

    // 重置筛选
    resetFilter() {
      this.filterForm = {
        username: '',
        status: ''
      }
      this.handleFilter()
    },

    // 分页大小变化
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.getUserList()
    },

    // 当前页变化
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.getUserList()
    },

    // 状态变化
    handleStatusChange(row) {
      this.$message.success(`用户 ${row.username} 状态已${row.status === '1' ? '启用' : '禁用'}`)
      // 这里应该是调用API更新状态
    },

    // 新增用户
    handleCreate() {
      this.isEditMode = false;
      this.dialogTitle = '新增用户'
      this.dialogVisible = true
    },

    // 编辑用户
    handleEdit(row) {
      this.dialogTitle = '编辑用户'
      this.userForm = {...row}
      this.dialogVisible = true
    },

    // 删除用户
    handleDelete(row) {
      this.$confirm(`确认删除用户 "${row.username}"?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 这里应该是调用API删除用户
        this.$message.success('删除成功')
        this.getUserList()
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },

    // 导出数据
    handleExport() {
      this.$confirm('确认导出用户数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 获取所有数据（不筛选不分页）
        const exportData = this.tableData.map(item => {
          return {
            id: item.id,
            username: item.username,
            name: item.name,
            email: item.email,
            phone: item.phone,
            role: this.$options.filters.roleFilter(item.role),
            status: item.status === '1' ? '启用' : '禁用',
            createTime: item.createTime
          }
        })

        const tHeader = ['ID', '用户名', '姓名', '邮箱', '手机号', '角色', '状态', '创建时间']
        const filterVal = ['id', 'username', 'name', 'email', 'phone', 'role', 'status', 'createTime']
        const filename = '用户数据'

        exportJsonToExcel(tHeader, exportData, filename, filterVal)
      }).catch(() => {
        this.$message.info('已取消导出')
      })
    },

    // 提交表单
    submitForm() {
      this.$refs.userForm.validate(valid => {
        if (valid) {
          this.$api.account.createAccount(this.userForm).then(res => {
            if (res.statusCode === 100200) {
              this.$message.success(this.dialogTitle + '成功')
              this.dialogVisible = false
              this.getUserList()
              this.getAccountSize()
            }
          })
          // 模拟API调用
          // setTimeout(() => {
          //   this.$message.success(this.dialogTitle + '成功')
          //   this.dialogVisible = false
          //   this.getUserList()
          // }, 500)
        } else {
          return false
        }
      })
    },

    // 重置表单
    resetForm() {
      this.$refs.userForm.resetFields()
      this.userForm = {
        id: '',
        username: '',
        name: '',
        email: '',
        phone: '',
        role: 'user',
        status: '1'
      }
    }
  }
}
</script>

<style scoped>
.user-management-container {
  padding: 20px 0 0 0;
  height: calc(100vh - 155px);
  display: flex;
  flex-direction: column;
}

.filter-container {
  margin-bottom: 20px;
  padding: 20px;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);

  /* 设置为flex容器 */
  display: flex;
  align-items: center;
}

.filter-form {
  /* 让表单占满可用空间 */
  width: 100%;
  display: flex;
  align-items: center;
}

.filter-container .el-form-item {
  margin-bottom: 0;
}

.add-btn-item {
  margin-left: auto;
}


.operation-buttons {
  margin-top: 10px;
}

.table-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
  padding: 20px;
}

.pagination-container {
  margin-top: 20px;
  text-align: right;
}

.el-table {
  flex: 1;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .filter-form {
    display: flex;
    flex-wrap: wrap;
  }

  .el-form-item {
    margin-right: 10px;
    margin-bottom: 10px;
  }

  .operation-buttons {
    display: flex;
    flex-wrap: wrap;
  }

  .el-button {
    margin-bottom: 10px;
  }
}
</style>